import {
    course_assignNewMedalByMerging_Api,
    course_copyCourse_Api,
    course_createCourse_Api,
    course_deleteCourse_Api,
    course_editCourse_Api,
    course_grantCertificateToStudentInCourse_Api,
    course_promoteStudents_Api,
    course_revokeCertificateFromStudentInCourse_Api,
} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes} from 'views/AppLocals/factory/createNotification'
import {successMessage} from 'views/AppLocals/factory/createMessageNotification'
import {bindQueryParams} from "../../functions/routerHelper";
import {showConfirmDialog, showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {TbCertificate, TbCertificateOff} from "react-icons/tb";

export const useCourseApi = ({
                                 owner_id,
                                 owner_type,
                                 autoRefresh = true,
                             }) => {
    const t = useTranslate()

    const [refreshKey, setRefreshKey] = useState()

    const onError = notifyOnError(t)

    const onRefresh = () => {
        if (autoRefresh) {
            setRefreshKey(Date.now())
        }
    }


    const {handleAsyncAction: onCourseCreate} = useAsyncAction({
        apiInfo: course_createCourse_Api,
        query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
        onError,
        onSuccess: () => {
            successMessage(NotificationActionTypes.CREATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: onCourseUpdate, isLoading: isUpdatingCourse} = useAsyncAction({
        apiInfo: course_editCourse_Api,
        onError,
        onSuccess: () => {
            successMessage(NotificationActionTypes.UPDATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: grantCertificateToStudentInCourse} = useAsyncAction({
        apiInfo: course_grantCertificateToStudentInCourse_Api,
        onError,
        onSuccess: () => {
            successMessage(NotificationActionTypes.UPDATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: revokeCertificateFromStudentInCourse} = useAsyncAction({
        apiInfo: course_revokeCertificateFromStudentInCourse_Api,
        onError,
        onSuccess: () => {
            successMessage(NotificationActionTypes.UPDATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: issueThirdCertificateIfEligible} = useAsyncAction({
        apiInfo: course_assignNewMedalByMerging_Api,
        onError,
        onSuccess: () => {
            successMessage(NotificationActionTypes.UPDATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: onCourseDuplicate} = useAsyncAction({
        apiInfo: course_copyCourse_Api,
        onError,
        onSuccess: () => {
            successMessage(NotificationActionTypes.CREATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: onCoursePromote, isLoading: isPromoting} = useAsyncAction({
        apiInfo: course_promoteStudents_Api,
        onError,
        onSuccess: () => {
            successMessage(NotificationActionTypes.UPDATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: onCourseDelete} = useAsyncAction({
        apiInfo: course_deleteCourse_Api,
        onError,
        onSuccess: () => {
            successMessage(NotificationActionTypes.DELETE, t)
            onRefresh()
        },
    })

    const confirmCourseDelete = (id) => {
        if (id) {
            showDeleteConfirmDialog({
                translate: t,
                title: 'delete course',
                message: 'are you sure you want to delete this course',
                onOk: () => {
                    onCourseDelete({}, {id})
                },
            })
        }
    }
    const confirmGrantCertificateToStudentInCourse = (id) => {
        if (id) {
            showConfirmDialog({
                icon: <TbCertificate className="text-green-500 anticon"/>,
                translate: t,
                title: 'grant to all students',
                onOk: () => {
                    grantCertificateToStudentInCourse({}, {id: id})
                },
            })
        }
    }
    const confirmRevokeCertificateFromStudentInCourse = (id) => {
        if (id) {
            showConfirmDialog({
                icon: <TbCertificateOff className="text-red-500 anticon"/>,
                translate: t,
                title: 'revoke all from students',
                onOk: () => {
                    revokeCertificateFromStudentInCourse({}, {id: id})
                },
            })
        }
    }


    return {
        onCourseCreate, onCourseUpdate, isUpdatingCourse,
        grantCertificateToStudentInCourse, revokeCertificateFromStudentInCourse, issueThirdCertificateIfEligible,
        onCourseDuplicate, onCourseDelete, onCoursePromote, isPromoting,
        confirmCourseDelete,
        confirmGrantCertificateToStudentInCourse, confirmRevokeCertificateFromStudentInCourse,
        refreshKey
    }
}
